import { css } from '@emotion/react';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
import styles from './Loader.module.css';

export interface LoaderProps {
    loading: boolean;
    color: string;
    size: number;
    className?: string;
}

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

export const Loader: FunctionComponent<LoaderProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <PulseLoader
                loading={props.loading}
                color={props.color}
                css={override}
                size={props.size}
            />
        </div>
    );
};

export default Loader;
